<div class="container mx-auto shadow-md rounded-lg relative max-w-[90vw] xl:max-w-[70rem]">
  <img
    src="assets/images/logos/company_logo_icon.svg"
    alt="Add Codi Logo"
    class="max-w-full h-auto absolute pt-3 ps-2"
  />
  <div class="grid lg:grid-cols-2 grid-cols-1 justify-center items-center loginBox">
    <div class="px-5 py-3">
      <div class="md:p-[4rem] p-4">
        <div class="flex justify-center">
          <i
            class="pi pi-key w-[42px] h-[42px] border border-neutral-200 rounded-[10px] !flex items-center justify-center bg-[linear-gradient(180deg,#FFFFFF_0%,#F1F1F1_115.48%)]"
          ></i>
        </div>
        <div class="pt-3 text-center">
          <span class="login-heading text-xl font-semibold text-neutral-900">{{
            'forgot_password.heading' | translate
          }}</span>
          <span class="login-subheading text-sm text-neutral-500 block">{{
            'forgot_password.subheading' | translate
          }}</span>
        </div>
        <form [formGroup]="forgotPassForm" class="flex flex-col gap-3 pt-4">
          <div class="flex flex-col">
            <label class="form-theme-label !text-sm" for="email">Email</label>
            <input
              pInputText
              id="email"
              aria-describedby="email-help"
              formControlName="email"
              pSize="small"
            />
            <!-- <small id="username-help">Enter your username to reset your password.</small> -->
          </div>
          <div>
            <p-button
              [raised]="true"
              (click)="onForgotPassword()"
              [disabled]="forgotPassForm.invalid || (authService.isLoading$ | async)"
              class="w-100-button"
            >
              @if ((authService.isLoading$ | async) === false) {
                <span>{{ 'auth.continue' | translate }}</span> →
              } @else {
                <span class="flex items-center justify-center gap-1">
                  <i class="pi pi-spin pi-spinner"></i>
                  <span class="leading-none">{{ 'auth.continue' | translate }}</span>
                </span>
              }
            </p-button>
            <div class="text-center pt-2">
              <a class="text-primary cursor-pointer font-medium text-sm" routerLink="/auth/login">
                ← <span>{{ 'auth.back_to_login' | translate }}</span>
              </a>
            </div>
          </div>
        </form>
      </div>
      <div
        class="auth-footer lg:absolute lg:w-1/2 bottom-0 lg:left-0 flex justify-between items-center lg:pt-0 px-4 lg:pb-2 sticky w-full pb-0"
      >
        <span class="rights-reserved text-xs text-neutral-500">{{
          'auth.rights_reserved' | translate
        }}</span>
        <p-select
          [options]="translateService.langOption"
          size="large"
          (onChange)="switchLang($event.value.value)"
          [(ngModel)]="translateService.selectedLanguage"
          optionLabel="name"
          [dt]="authService.getDesignTokens()"
        >
          <ng-template #selectedItem let-selectedOption>
            <div class="flex items-center gap-2">
              <img
                [src]="translateService.selectedLanguage.image"
                class="w-[18px]"
                alt="Country Flag"
              />
              <div>{{ selectedOption.name }}</div>
            </div>
          </ng-template>
          <ng-template let-lang #item>
            <div class="flex items-center gap-2">
              <img [src]="lang.image" class="w-[18px]" alt="Country Flag" />
              <div>{{ lang.name }}</div>
            </div>
          </ng-template>
        </p-select>
      </div>
    </div>

    <div class="px-0 lg:block hidden">
      <img
        src="assets/images/backgrounds/login_frame.png"
        alt="Login Background"
        class="max-w-full h-auto rounded-lg"
      />
    </div>
  </div>
</div>
